<div class="flex flex-col gap-6">
  <div class="w-full">
    <zaeper-card>
      <p-button (onClick)="openCreateAppModal()" [rounded]="true">App erstellen</p-button>
    </zaeper-card>
  </div>
  <div class="grid w-full cols-auto-fill-[350px] gap-6">
    @for (app of apps$(); track app) {
      <app-application-overview-item (onClick)="openAppDetailPage(app.id)" [application]="app" styleClass="cursor-pointer">
        <ng-template #actions>
          <p-button (onClick)="deleteApp($event, app)" icon="pi pi-trash" [rounded]="true" severity="secondary" />
        </ng-template>
      </app-application-overview-item>
    }
  </div>
</div>
